








































import { Vue, Component } from "vue-property-decorator";
import authModel from "@/models/auth.model";

@Component({
})
export default class ClientLogin extends Vue {
    userInfo: any = {
        email: "",
        cnpj: "",
        loginConfirmationCode: "",
    };
    visibleCode = false;
    visibleGetCode = true;
    async getPinCodeByEmail() {
        //validar email e cnpj
        if (!this.userInfo.email || !this.userInfo.cnpj) {
            this.$vs.notification({
                title: "Erro",
                text: "Informar o E-mail e Cnpj.",
                color: "#FF6767",
            });
            return;
        }

        try {
            await authModel.requestLoginCodeCnpj(this.userInfo.email, this.userInfo.cnpj);
            this.$vs.notification({ color: "success", title: "Sucesso", text: "O código foi enviado para o seu e-mail." });
            this.visibleCode = true;
            this.visibleGetCode = false;
          
        } catch (error) {
            if (error.statusCode === 404 || error.message === 'Not Found' || error.message === 'API_NOT_FOUND') {
                error.message = "E-mail não cadastrado."
            }
            this.$vs.notification({
                title: 'Erro',
                text: error.message,
                color: 'danger'
            });
            console.error(error);
        }
    }

    async loginByPin() {
        if (!this.userInfo.loginConfirmationCode) {
            return;
        }

        try {
        //this.loadingButton = true;
        //this.disableButton = true;
        await this.$store.dispatch("auth/loginCnpj", { emailStatistics: this.userInfo.email, cnpj: this.userInfo.cnpj, loginConfirmationCode: this.userInfo.loginConfirmationCode });
      } catch (error) {
        if (error.message === "Account is pending approval") {
          error.message = "Sua conta ainda não foi aprovada";
        }
        this.$vs.notification({
          title: 'Erro',
          text: error.message,
          // iconPack: 'feather',
          // icon: 'icon-alert-circle',
          color: 'danger'
        });
        console.error(error);
        //this.loadingButton = false;
        //this.disableButton = false;
      }
    }
}

